import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { CarouselModule } from '@df/ui-carousel/carousel.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { Swiper } from 'swiper';
import { SwiperEvents } from 'swiper/types';
import { NBuilderConfig } from '../builder.config';
export interface IStepSelection {
    tabId: number;
    optionName: string;
}
@Component({
    selector: 'simple-step',
    templateUrl: './simple-step.html',
    standalone: true,
    imports: [ICmsClientModule, NgClass, CarouselModule, ImageModule],
    styleUrls: ['./simple-step.scss']
})
export class BuilderSimpleStepComponent extends UiComponent implements OnInit, OnChanges {
    @Input()
    content: NBuilderConfig.ISimpleStep;

    @Input()
    selection: IStepSelection;

    @Output()
    selectionChange = new EventEmitter<IStepSelection>();

    @Input()
    squareVariant = false;

    private swipers: {
        [tabId: number]: Swiper;
    } = {};
    override ngOnChanges(changes: SimpleChanges): void {
        if (!this.selection) {
            this.selection = {
                tabId: this.content.tabs[0].id,
                optionName: ''
            };
            this.preselectOption();
        }
        super.ngOnChanges(changes);
    }
    changeActiveTab(id: number) {
        this.selection.tabId = id;
        this.preselectOption();
        this.detectChanges();
    }
    isActive(name: string, tabId: number): boolean {
        return this.selection?.tabId === tabId && this.selection?.optionName === name;
    }
    selectOption(name: string) {
        this.selection = { tabId: this.selection.tabId, optionName: name };
        this.detectChanges();
        this.selectionChange.emit(this.selection);
    }

    getIndexOfSelection(tabOptions: NBuilderConfig.ISetupElementData[]) {
        return tabOptions.findIndex(o => o.name === this.selection.optionName);
    }
    isLoop(slides: number): boolean {
        return slides > (this.squareVariant ? [1, 1, 3, 4] : [1, 1, 5, 6])[this.client.sizeId];
    }
    onAfterInit(eventParams: Parameters<SwiperEvents['afterInit']>, tabId: number) {
        const [swiper] = eventParams;
        this.swipers[tabId] = swiper;
    }
    private preselectOption() {
        const options = this.content.tabs.find(tab => tab.id === this.selection.tabId)?.options;
        if (options?.length) {
            this.selectOption(options.find(option => option.preselect)?.name || options[0].name);
            this.slideToSelection(options);
        }
    }
    private slideToSelection(tabOptions: NBuilderConfig.ISetupElementData[]) {
        if (this.swipers[this.selection.tabId]) {
            const index = this.getIndexOfSelection(tabOptions);
            this.swipers[this.selection.tabId].slideTo(
                index >= 0 ? (this.isLoop(tabOptions.length) ? index + tabOptions.length : index) : 0 // plus lenght to avoid white space on
            );
        }
    }
    get pcSlides() {
        return this.squareVariant ? [1.5, 1.5, 3.65, 4.65][this.client.sizeId] : [2.2, 2.2, 5.1, 6.1][this.client.sizeId];
    }
    get pcSlidesCeil() {
        return Math.ceil(this.pcSlides);
    }
    get pcGutter() {
        return (this.client.sizeId < 2 ? 8 : 40) + 'px';
    }
}
